import React from 'react'
import './featuredReviews.css'
import { Columns } from '../../elements'

export const ReviewElement = ({
  imageURL,
  linkURL,
  name,
  bodyText,
  linkText,
}) => (
  <div className="list-motorcycle-review">
    <Columns className="is-vcentered">
      <Columns.Column size={5} className="insurance-moto-review-image">
        <img src={imageURL} alt={name} />
      </Columns.Column>
      <Columns.Column size={6} offset={1}>
        <div className="insurance-quote-block">
          <i className="fal fa-quote-left insurance-marketing-quote-icon"></i>
          <p className="insurance-testimonial-block">
            {bodyText}
            <br />
            <strong>{name}</strong>
          </p>
        </div>
      </Columns.Column>
    </Columns>
  </div>
)

export const FeaturedReviews = () => (
  <>
    <ReviewElement
      imageURL={
        'https://res.cloudinary.com/twisted-road/image/upload/fl_progressive,c_scale,q_auto,h_660,f_auto/v1566592705/frontend_assets/marketing/danielev.jpg'
      }
      linkURL={
        '/bikes/us/ca/west-hollywood/2015-Ducati-Scrambler-Classic/M-PEGNY9G'
      }
      name={'Danielle V.'}
      bodyText={`I've rented my motorcycle out on Twisted Road nearly a dozen times over the past year. It is an outstanding service that makes me extra cash each month. Every renter I've had treated my motorcycle like their own. The Twisted Road team checks in on each rental and I rest easy knowing I'm covered by their insurance.`}
      linkText="Danielle rents her 2015 Ducati Scrambler Classic with us."
    />
    <ReviewElement
      imageURL={
        'https://res.cloudinary.com/twisted-road/image/upload/c_fill,h_450,w_450/v1568781351/frontend_assets/marketing/RFO17.jpg'
      }
      linkURL={'/users/U-LXMG4ZX'}
      name={'Jason Paul Michaels.'}
      bodyText={`We have a shop with several bikes available for sale and while we’re
            waiting for that new owner — we rent them out on Twisted Road. The
            team behind TR is bar-none one of the best we’ve worked with not in
            just the the rental space, but business in general. We couldn’t be
            happier with the results and opportunities that have come from
            working with them!`}
      linkText="- Jason Paul Michaels | STANDARD M/C"
    />
  </>
)
